import React from "react";
import Form from "../../../Common/Components/Form";
const Create = () => {
  return (
    <div>
      {/* <Form
        form={input}
        loading={state.loading}
        header="ایجاد مقاله"
        textbtn="لیست مقالات"
        linkbtn="/Admin/blog/List"
        btnName="ایجاد مقاله"
        submit={Handler}
        nested={["tags", "blogcategory"]}
        textEditor={"content"}
      /> */}
    </div>
  );
};

export default Create;
export const input = [
  {
    label: "عنوان مقاله",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "title",
    value: "",
  },

  {
    label: "انتخاب تگ ها",
    size: "col-md-3",
    classNames: "mt-2",
    placeholder: "",
    name: "tag_id",
    input: "selectTable",
    multiple: true,
    nested: "tags",
  },
  {
    label: "انتخاب دسته بندی",
    size: "col-md-3",
    classNames: "mt-2",
    placeholder: "",
    name: "category_id",
    input: "select",
    nested: "blogcategory",
  },
  {
    label: "توضیحات",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "description",
    input: "textarea",
  },
  {
    label: "متن مقاله",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "content",
    input: "ckeditor",
  },
  {
    label: "کلمات کلیدی سئو",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoKeyword",
    value: "",
    input: "textarea",
  },
  {
    label: "توضیحات کلیدی سئو",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "seo",
    keyname: "seoDescription",
    value: "",
    input: "textarea",
  },
  {
    label: "تصویر مقاله",
    size: "col-md-4",
    classNames: "mt-2",
    placeholder: "",
    name: "image",
    input: "file",
    alt: true,
    accept: "image/png, image/jpeg",
  },
];
